import React, { useEffect, useState } from 'react'
import PageHeader from '../../../components/pageHeader/PageHeader';
import PageButtons from '../../../components/pageComponents/PageButtons';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../../hooks/useDidMountEffect/useDidMountEffect';
import { useGetRequest } from '../../../hooks/useGetRequest/useGetRequest';
import { useManagePostRequest } from '../../../hooks/useManagePostRequest/useManagePostRequest';

import { initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData } from '../../../helper/utils';
import {
  getAllCargosAPI,
  getAllEstadosAPI,
  getAllSedesAPI,
  getAllDepartamentosAPI,
  getAllTiposFaltaAPI,
  getPeriodosForFiltroListarFaltasAPI, getListaMisFaltasAPI
} from "../../../consumers/backendApisUrls";
import {isNullOrUndefinded} from "../../../helper/utils";
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import Select from "react-select";
import styled from "styled-components";
import ModalEnabled from "../../../components/modalComponents/ModalEnabled";
import TableFaltas from "./TableFaltas";

const INIT_KEYS = {
  IdsTipoFaltas: "IdsTipoFaltas",
  IdsEstadosEmpleado: "IdsEstadosEmpleado",
  IdsDepartamentos: "IdsDepartamentos",
  IdsCargos: "IdsCargos",
  IdsSedes: "IdsSedes",
  IdsEstados: "IdsEstados",
};

const MisFaltas = () => {

  const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
  const [allFilters, setAllFilters] = useState([]);
  const [idsFaltasConCheck, setIdsFaltasConCheck] = useState([]);

  const [searchCriteria, setSearchCriteria] = useState("");
  const [paginator, setPaginator] = useState({CurrentPage: 1});
  const [isLoading, setIsLoading] = useState(true);

  const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

  const [executeGet] = useGetRequest();
  const [executeManagePost] = useManagePostRequest();
  const [executeManageGet] = useManageGetRequest();

  const [allPeriodos, setallPeriodos] = useState([]);
  const [selectedPeriodo, setSelectedPeriodo] = useState();

  const initialPromises = () => {
    const response = executeGet(getAllEstadosAPI());

    return [
      executeGet(getAllTiposFaltaAPI()),
      response,
      executeGet(getAllDepartamentosAPI()),
      executeGet(getAllCargosAPI()),
      executeGet(getAllSedesAPI()),
      response
    ];
  }

  const init = async () => {
    setIsLoading(true);
    try {
      await manageSearch();
      await getAllPeriodos();
      await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
      if (formValues.filters.length === 0) {
        jsonNoEstaVacio(formValues.ExtraData) &&
        updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  const manageSearch = async () => {
    if (!isNullOrUndefinded(selectedPeriodo?.value)) {
      setIsLoading(true);
      const api = getListaMisFaltasAPI();
      const payload = getPayload();
      await executeManagePost(api, payload, successManageSearchCallback);
      setIdsFaltasConCheck([]);
      setIsLoading(false);
    }
  }

  const getPayload = () => {
    return {
      Criteria: searchCriteria,
      Page: paginator.CurrentPage,
      IdFaltaPeriodo: selectedPeriodo?.value,
      ...formValues.selectedFilters
    }
  }

  const getAllPeriodos = async () => {
    const api = getPeriodosForFiltroListarFaltasAPI();
    await executeManageGet(api, (res) => successGetAllPeriodosCallback(res), false);
  }

  const successGetAllPeriodosCallback = ({data}) => {
    const items = data.map(o => ({value: o.IdFaltaPeriodo, label: o.Nombre}));
    setallPeriodos(items);
    if (items.length > 0)
      setSelectedPeriodo(items[0])
  }

  const successManageSearchCallback = ({data}) => {
    const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
    setFormValues(lastData => ({...lastData, Items, ExtraData}));
    setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
    setIsLoading(false);
  }

  const handleUpdatedFilters = (res) => {
    setFormValues(lastData => ({...lastData, filters: res}))
  }

  const handleCleanSearch = () => {
    setFormValues({...formValues, selectedFilters: null});
  }

  useDidMountEffect(() => {
    manageSearch();
  }, [paginator.CurrentPage, formValues.selectedFilters, selectedPeriodo])

  useDidMountEffect(() => {
    jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
  }, [formValues.ExtraData])

  useEffect(() => {
    init();
  }, [])

  return (
      <PageWrapper isLoading={isLoading}>
        <ModalEnabled
            modalEnabled={modalEnabled}
            setModalEnabled={setModalEnabled}
            refreshPage={manageSearch}
        />
        <PageHeader title="Mis Faltas"/>

        <SearchContainer
            searchCriteria={searchCriteria}
            setSearchCriteria={setSearchCriteria}
            setPaginator={setPaginator}
            manageSearch={manageSearch}
            addCleanSearch={handleCleanSearch}>
          <ButtonsWrapper>
            <PageButtons>

            </PageButtons>
          </ButtonsWrapper>
        </SearchContainer>

        <TableFaltas
            formValues={formValues}
            setFormValues={setFormValues}
            extraData={formValues.ExtraData}
            setModalEnabled={setModalEnabled}
            paginator={paginator}
            setPaginator={setPaginator}
            keys={INIT_KEYS}
            idsFaltasConCheck={idsFaltasConCheck}
            setIdsFaltasConCheck={setIdsFaltasConCheck}
            fromAdminPage={false}
        />
      </PageWrapper>
  );
}

export default MisFaltas;

const SelectPeriodos = ({items, selectedItem, setSelectedItem}) => (
    <div className='col-sm-4 mt-2 ml-2'>
      <Select
          placeholder="Seleccionar Periodo"
          options={items}
          value={selectedItem}
          onChange={(res) => setSelectedItem({...res})}
      />
    </div>
)

const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;
